import React from "react";
import shortid from "shortid";
import { withRouter, Link } from "react-router-dom";
import * as actionTypes from "../../../store/actions/actionTypes";
import { connect } from "react-redux";
import qString from "query-string";
import windowSize from "react-window-size";
import ImageLoader from "../../Common/ImageLoader";

const regexForCategory = new RegExp("^/(software|services)/:domain(/all)?$");

class VendorTab extends React.Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    this.state = {
      size: [],
      ind: [],
      loc: [],
      sort: "",
      sortOptions: [
        {
          label: "Most Awards",
          value: "aw",
        },
        {
          label: "Most References",
          value: "r",
        },
        {
          label: "A to Z",
          value: "a",
        },
      ],
      companyOptions: [
        {
          label: "SMB (1-200)",
          value: 1,
        },
        {
          label: "Mid-Market (201-1000)",
          value: 200,
        },
        {
          label: "Enterprise (1001+)",
          value: 1001,
        },
      ],
      toggleCompanySizeDD: false,
      toggleIndustryeDD: false,
      toggleLocationeDD: false,
      indSearchKeyword: "",
      smallScreenFilter: true,
      hasError: false,
    };
    this.toggleDropDown = this.toggleDropDown.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSortChange = this.handleSortChange.bind(this);
    this.getSearchParams = this.getSearchParams.bind(this);
    this.composeNumbers = this.composeNumbers.bind(this);
    this.onChangeCheckbox = this.onChangeCheckbox.bind(this);
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {}

  UNSAFE_componentWillMount() {
    this._isMounted = true;
    const qObject = qString.parse(this.props.location.search);
    const tempObj = {};
    if (qObject.size) {
      tempObj["size"] = qObject.size.split(",").map((id) => Number(id));
    }
    if (qObject.ind) {
      tempObj["ind"] = qObject.ind.split(",").map((id) => Number(id));
    }
    if (qObject.loc) {
      tempObj["loc"] = qObject.loc.split(",");
    }
    if (qObject.sort) {
      tempObj["sort"] = qObject.sort;
    }
    if (this._isMounted) {
      this.setState({ ...tempObj });
    }
  }

  composeNumbers = (totalItemsCount, numberOfItemsPerPage, page) => {
    const start = !!totalItemsCount
      ? page * numberOfItemsPerPage - (numberOfItemsPerPage - 1)
      : totalItemsCount;
    const end = Math.min(start + numberOfItemsPerPage - 1, totalItemsCount);

    return `${start}-${end}`;
  };

  handleChange = (params) => {
    if (
      this._isMounted &&
      this.state[params["name"]].indexOf(params["value"]) === -1
    ) {
      this.setState(
        (prevState) => {
          return {
            [params["name"]]: [...prevState[params["name"]], params["value"]],
          };
        },
        () => {
          this.props.setDataLoadedFalseList();
          this.props.history.push(this.getSearchParams());
        }
      );
    } else {
      const tempArr = [...this.state[params["name"]]];
      tempArr.splice(tempArr.indexOf(params["value"]), 1);
      if (this._isMounted) {
        this.setState(
          (prevState) => {
            return { [params["name"]]: tempArr };
          },
          () => {
            this.props.setDataLoadedFalseList();
            this.props.history.push(this.getSearchParams());
          }
        );
      }
    }
  };

  handleSortChange = (event) => {
    event.persist();
    if (this._isMounted) {
      this.setState(
        (prevState) => {
          return { sort: event.target.value };
        },
        () => {
          this.props.setDataLoadedFalseList();
          this.props.history.push(this.getSearchParams());
        }
      );
    }
  };

  toggleDropDown = (name, rest) => {
    const ddOpt = [
      "toggleCompanySizeDD",
      "toggleIndustryeDD",
      "toggleLocationeDD",
    ];

    if (this._isMounted && ddOpt.indexOf(name) !== -1) {
      this.setState((prevState) => {
        return {
          [name]: !prevState[name],
          ...rest,
        };
      });
    }
  };

  onChangeCheckbox = (value) => {
    console.log("Value :: ", value);
    if (this.state.size.indexOf(value) === -1) {
      this.setState(
        (prevState) => {
          return {
            size: [...prevState.size, value],
          };
        },
        () => {
          console.log(``);
          this.getSearchParams();
          this.props.history.push(this.getSearchParams());
        }
      );
    } else {
      let tempValues = [...this.state.size];
      tempValues.splice(tempValues.indexOf(value), 1);
      this.setState(
        (prevState) => {
          return { size: tempValues };
        },
        () => {
          console.log(``);
          this.props.history.push(this.getSearchParams());
        }
      );
    }
  };

  getSearchParams = () => {
    if (!!this.state.sort && this.state.size.length > 0) {
      console.log(
        "Both :: ",
        `${this.props.location.pathname}?sort=${this.state.sort}&size=${this.state.size}`
      );
      return `${this.props.location.pathname}?sort=${this.state.sort}&size=${this.state.size}`;
    } else if (!!this.state.sort && this.state.size.length === 0) {
      console.log(
        "Sort :: ",
        `${this.props.location.pathname}?sort=${this.state.sort}`
      );
      return `${this.props.location.pathname}?sort=${this.state.sort}`;
    } else if (this.state.size.length > 0 && !this.state.sort) {
      console.log(
        "Size :: ",
        `${this.props.location.pathname}?size=${this.state.size}`
      );
      return `${this.props.location.pathname}?size=${this.state.size}`;
    }
  };

  render() {
    if (this.state.hasError) {
      window.location.reload();
    }
    return (
      <React.Fragment>
        <div
          className={
            this.props.match.path.includes("/:domain/:location")
              ? `vendor_search_bg geolocation_search_section`
              : `vendor_search_bg `
          }
        >
          <div className="verdorSearch">
            <div
              className={
                regexForCategory.test(this.props.match.path)
                  ? `vendorResults vendorResult_category`
                  : `vendorResults`
              }
            >
              {
                <span className="resultDisplay">
                  {!!this.props.vendorCategory &&
                    !!this.props.vendorCategory.result_count &&
                    `${this.composeNumbers(
                      this.props.vendorCategory.result_count,
                      this.props.currentView === "all"
                        ? 100
                        : Number(this.props.currentView),
                      Boolean(qString.parse(this.props.location.search).p)
                        ? Number(qString.parse(this.props.location.search).p)
                        : 1
                    )} of ${this.props.vendorCategory.result_count.toLocaleString()}`}
                  <span className="txt">
                    {` ${this.props.vendorCategory?.category_name} companies`}
                  </span>
                </span>
              }
            </div>
            <div
              className={
                regexForCategory.test(this.props.match.path)
                  ? `vendorFilter sortingfilter_category`
                  : `vendorFilter`
              }
            >
              <div className="sortingFilter sorting_tab">
                {!!this.props.match &&
                !!this.props.match.path &&
                this.props.match.path.includes("/:domain/:location") ? (
                  <>
                    <span className="txt">Filter</span>
                    <span className="close_btn">
                      <a href="#">Close</a>
                    </span>
                    <ul>
                      <li>
                        <span
                          className="filter_box"
                          onClick={(e) => {
                            e.preventDefault();
                            console.log("Got Clicked");
                            this.setState((prevState) => {
                              return {
                                toggleCompanySizeDD:
                                  !prevState.toggleCompanySizeDD,
                              };
                            });
                          }}
                        >
                          Company Size
                          <img src="/images/arrow_down.webp" alt="" />
                        </span>
                        <ul
                          style={
                            this.state.toggleCompanySizeDD
                              ? { display: "block" }
                              : { display: "none" }
                          }
                        >
                          {this.state.companyOptions &&
                            this.state.companyOptions.map((locOption) => (
                              <li
                                key={shortid.generate()}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  e.persist();
                                  this.onChangeCheckbox(locOption.value);
                                }}
                              >
                                <input
                                  type="checkbox"
                                  value={locOption.value}
                                  name={`size_${locOption.value}`}
                                  checked={
                                    this.state.size.indexOf(locOption.value) ===
                                    -1
                                      ? false
                                      : true
                                  }
                                  onChange={(e) => {}}
                                />
                                <label htmlFor={`size_${locOption.value}`}>
                                  {locOption.label}
                                </label>
                              </li>
                            ))}
                        </ul>
                      </li>
                    </ul>
                  </>
                ) : null}
                <div className="selectdiv">
                  <select
                    className="sortBy"
                    onClick={(e) => {
                      if (this._isMounted) {
                        this.setState({
                          toggleLocationeDD: false,
                          toggleCompanySizeDD: false,
                          toggleIndustryeDD: false,
                        });
                      }
                    }}
                    value={this.state.sort}
                    onChange={(e) => {
                      this.handleSortChange(e);
                    }}
                  >
                    <option>Sort By</option>
                    {this.state.sortOptions &&
                      this.state.sortOptions.map((locOption) => (
                        <option
                          key={shortid.generate()}
                          value={locOption.value}
                        >
                          {locOption.label}
                        </option>
                      ))}
                  </select>
                </div>
                <span
                  className="reset"
                  onClick={(e) => {
                    e.preventDefault();
                    if (this._isMounted) {
                      this.setState({
                        size: [],
                        ind: [],
                        loc: [],
                        sort: "",
                        toggleCompanySizeDD: false,
                        toggleIndustryeDD: false,
                        toggleLocationeDD: false,
                        indSearchKeyword: "",
                      });
                    }
                    this.props.history.push(
                      `${this.props.location.pathname}?p=1`
                    );
                  }}
                >
                  <a href="#reset">Reset</a>
                </span>
              </div>
            </div>
          </div>
          {!!this.props.vendorCategory &&
            !!this.props.vendorCategory.featured_vendors &&
            !!this.props.vendorCategory.featured_vendors.length &&
            this.props.vendorCategory.featured_vendors.length >= 5 && (
              <div className="premium_customer_block">
                {/* <div className="ribbon ribbon-top-right premium">
                  <span>
                    {' '}
                    <div className="ribbonTxt">PREMIUM</div>
                  </span>
                </div> */}
                <div className="premium_customer_box">
                  <div className="left">
                    <span className="heading">
                      {`Premium ${this.props.vendorCategory.category_name} Vendors`}
                    </span>
                    <p>
                      {/* {`XXX Find the best  ${this.props.vendorCategory.category_name} companies for
                  your business. Compare case studies, success stories, &
                  testimonials from the top ${this.props.vendorCategory.category_name}
                  vendors.`} */}
                      {`Browse ${this.props.vendorCategory?.review_counts?.testimonials?.toLocaleString()} reviews, ${this.props.vendorCategory?.review_counts?.case_studies?.toLocaleString()} case studies & customer success stories, and ${this.props.vendorCategory?.review_counts?.videos?.toLocaleString()} customer videos of the best ${
                        this.props.vendorCategory.category_name
                      } for your business needs`}
                    </p>
                  </div>
                  <div className="right">
                    {!!this.props.vendorCategory &&
                      !!this.props.vendorCategory.featured_vendors &&
                      !!this.props.vendorCategory.featured_vendors.length &&
                      this.props.vendorCategory.featured_vendors.length >= 5 &&
                      this.props.vendorCategory.featured_vendors.map(
                        (featured_vendor) => (
                          <div className="logo">
                            <Link
                              to={featured_vendor.profile_url}
                              title={featured_vendor.name}
                            >
                              {/* <ImageLoader
                              image={featured_vendor.logo}
                              fallbackImage={
                                '/static/images/FC-Generic-Logo.webp'
                              }
                            /> */}
                              <img
                                src={featured_vendor.logo}
                                alt={`${featured_vendor.name} logo`}
                                width={160}
                                height={50}
                              />
                            </Link>
                          </div>
                        )
                      )}
                  </div>
                </div>
              </div>
            )}
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    vendorCategory: state.vendorCategory,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setDataLoadedFalseList: () =>
      dispatch({
        type: actionTypes.SET_CATEGORY_DATALOADER_FALSE,
      }),
  };
};

const WindowSizeOfVendorTab = windowSize(VendorTab);
const VendorTabWithRouter = withRouter(WindowSizeOfVendorTab);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VendorTabWithRouter);
